/**
 * Cart Drawer Raf app bridge — open drawer after any successful /cart/add fetch
 */
(function () {
  'use strict';

  function isCartAddUrl(url) {
    if (!url || typeof url !== 'string') return false;
    try {
      var path = new URL(url, window.location.origin).pathname;
      return path === '/cart/add' || path === '/cart/add.js' || path.endsWith('/cart/add') || path.endsWith('/cart/add.js');
    } catch (e) {
      return false;
    }
  }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;

  window.fetch = function (url, options) {
    var args = arguments;
    return originalFetch.apply(this, args).then(function (response) {
      var method = (options && options.method) ? String(options.method).toUpperCase() : 'GET';
      if ((method === 'POST' || method === 'PUT') && isCartAddUrl(typeof url === 'string' ? url : (url && url.url)) && response.ok) {
        response.clone().json().then(function (body) {
          if (body && (body.status === 422 || body.status === 'bad_request')) return;
          openDrawer();
        }).catch(function () {
          openDrawer();
        });
      }
      return response;
    });
  };
})();
